const formatEditSetFormUpsert = ({ initialSelectedSchedule, setValue }) => {
  setValue('title', initialSelectedSchedule?.eventName);
  setValue(
    'accountLivestreamId',
    initialSelectedSchedule.accounts.map((account) => {
      return {
        value: account?.id,
        label: `${account?.name} (${account.ecommerce.name})`,
        brandName: account?.brandName,
      };
    }),
  );
  setValue(
    'hostId',
    initialSelectedSchedule.hosts.map((host) => {
      return {
        value: host.id,
        label: host.name,
      };
    }),
  );
  setValue(
    'operatorId',
    initialSelectedSchedule.operators.map((operator) => {
      return {
        value: operator.id,
        label: operator.name,
      };
    }),
  );
  setValue('studioId', {
    value: initialSelectedSchedule?.studio?.id,
    label: `${initialSelectedSchedule?.studio?.name}`,
  });
  setValue('reason', initialSelectedSchedule?.reason);

  return null;
};

export default formatEditSetFormUpsert;
